module.exports = __webpack_public_path__ + "static/media/mobile_interiors_hero.035831ed.jpg";